"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";
import type { User } from "@supabase/supabase-js";

import type { UserProfile } from "@/lib/supabase/types";

interface SessionContextValue {
  user: User | null;
  profile: UserProfile | null;
}

const SessionContext = createContext<SessionContextValue | undefined>(undefined);

interface SessionProviderProps {
  children: ReactNode;
  user: User | null;
  profile: UserProfile | null;
}

export function SessionProvider({ children, user, profile }: SessionProviderProps) {
  const value = useMemo(() => ({ user, profile }), [user, profile]);

  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession() {
  const context = useContext(SessionContext);

  if (!context) {
    throw new Error("useSession must be used within a SessionProvider");
  }

  return context;
}
